<template>
  <BasicModal
    :title="title"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="card-content parent-box">
      <div class="box-request">
        <p style="text-align: left; padding: 15px;">
          Cybozu Officeとのスケジュール同期を行うことが可能です。<br/>
          ※ WSDLのパス については、システム担当者にお伺いください。
        </p>
        <div style="text-align: left; padding: 15px;">
          WSDLのパス：
          <input class="input" style="width: 358px; height: 24px; color: #222; font-size: 16px;" placeholder="http://localhost:9080/scripts/cbag/ag.exe?WSDL" v-model="user.cybozu_office_wsdl"/>
        </div>
        <div style="text-align: left; padding: 15px;">
          Cybozu Office のログイン名：
          <input class="input" style="width: 250px; height: 24px; color: #222; font-size: 16px;" placeholder="Cybozu Office のログイン名" v-model="user.cybozu_office_id"/>
        </div>
        <div style="text-align: left; padding: 15px;">
          Cybozu Office のパスワード：
          <input class="input" style="width: 250px; height: 24px; color: #222; font-size: 16px;" placeholder="*******" v-model="user.cybozu_office_secret"/>
        </div>
        <div style="text-align: left; padding: 15px;">
          Cybozu Office のユーザーID：
          <input class="input" style="width: 250px; height: 24px; color: #222; font-size: 16px;" placeholder="16" v-model="user.cybozu_office_uid"/>
        </div>
        <div style="text-align: left; padding: 15px;">
          Basic 認証：
          <b-switch size="is-small" v-model="user.cybozu_office_basic">切替</b-switch>
          <span style="margin-left: 17px; margin-right: 5px;">ID</span>
          <input class="input" style="width: 80px; height: 24px; color: #222; font-size: 16px;" placeholder="basic" v-model="user.cybozu_office_basic_id"/>
          <span style="margin-left: 17px; margin-right: 5px;">パスワード</span>
          <input class="input" style="width: 80px; height: 24px; color: #222; font-size: 16px;" placeholder="*******" v-model="user.cybozu_office_basic_pw"/>
        </div>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button @click="$emit('saveCybozuOffice')" class="button is-primary" v-if="!authType">
        保有アカウントと連携する
      </button>
      <button @click="$emit('saveCybozuOffice')" class="button is-primary" :disabled="!user.cybozu_office_id" v-if="authType === 'cybozu'">
        設定を保存する
      </button>
      <button class="button is-danger" v-if="authType === 'cybozu'" @click="clickDeleteCybozuOffice">連携解除</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
export default {
  name: 'ModalCybozuOffice',
  componentName: 'ModalCybozuOffice',
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      require: true
    },
    authType: {
      type: String,
      require: true
    },
    user: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
      title: 'Cybozu Ofiice 連携'
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    clickDeleteCybozuOffice () {
      this.$emit('delete-cybozuOffice')
    },
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}
.setting-card {
  height: 100px;
  width: 280px;
  border-radius: 8px;
  border: solid thin #ccc;
  margin: 8px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    font-weight: 600;
    color: #C82E42;
    margin-bottom: 8px;
  }
  .input-box {
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      margin-left: 8px;
    }
    select {
      max-width: 200px;
    }
  }
}
.action-box {
  width: calc(100% - 32px);
  height: 48px;
  display: flex;
  align-items: center;
  margin-left: 16px;
  p {
    margin-left: 16px;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 30%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/organisms/ModalCybozuOffice.vue